// extracted by mini-css-extract-plugin
module.exports = {"why__section":"why-module--why__section--3PpBs","why__heading":"why-module--why__heading--3dvbG","why__paragraph":"why-module--why__paragraph--m8AyL"};